import { useLanguage } from "src/components/utils"

const text = {   
    ko: [
        // map
        [
            `대전 본사`,
            `대전광역시 서구 청사로 136, 대전무역회관 18층 R1846호(월평동)`,
            `서울 연구소`,
            `서울 서초구 매헌로8길 47, 희경빌딩 B동 405호\n `,
            `미국 지사`,
            `4185 SILVER PEAK PKWY, SUITE A, SUWANEE, GA, 30024, USA\n `,
        ],
        // footer
        [
            `CONTACT`,
            `contact@deargen.me`,
            `ⓒ 2026 DEARGEN Inc.`,
        ],
    ],    
    en: [
        // map
        [
            `Daejeon Office`,
            `R1846, 18F, 136, Cheongsa-ro, Seo-gu, \nDaejeon, Korea`,
            `Seoul Research Center`,
            `47, Maeheon-ro 8-gil, Seocho-gu, \nSeoul, Korea`,
            `U.S. Office`,
            `4185 SILVER PEAK PKWY, SUITE A, SUWANEE, GA, 30024, USA`,
        ],
        // footer
        [
            `CONTACT`,
            `contact@deargen.me`,
            `ⓒ 2026 DEARGEN Inc.`,
        ],
    ]
}


export default function useContent() {
    const language = useLanguage()
    const 컨텐츠 = text[language]
    return { 컨텐츠 }
}